var _excluded = ["className", "content", "title", "role", "aria-labelledby", "aria-hidden"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
var Icon = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
    className,
    content,
    title,
    role,
    'aria-labelledby': ariaLabelledby,
    'aria-hidden': ariaHidden
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var iconIdOld = useRef('icon_' + uuidv4()); // eslint-disable-next-line react-hooks/rules-of-hooks

  var iconId = React.useId ? 'icon_' + React.useId() : iconIdOld.current;
  var {
    'aria-label': ariaLabel,
    'aria-describedby': ariaDescribedby
  } = otherProps;
  var hasLabel = !!title || !!ariaLabelledby || !!ariaLabel || !!ariaDescribedby;
  return useMemo(() => {
    var _content$props;

    return /*#__PURE__*/React.cloneElement(content, _objectSpread({
      children: /*#__PURE__*/React.createElement(React.Fragment, null, title ? /*#__PURE__*/React.createElement("title", {
        id: iconId
      }, title) : null, content === null || content === void 0 ? void 0 : (_content$props = content.props) === null || _content$props === void 0 ? void 0 : _content$props.children),
      className,
      ref,
      focusable: false,
      role,
      'aria-labelledby': ariaLabelledby || (title ? iconId : undefined),
      'aria-hidden': typeof ariaHidden !== 'undefined' ? ariaHidden : !hasLabel
    }, otherProps));
  }, [content, className, title, role, hasLabel, ref, ariaLabelledby, ariaHidden, otherProps, iconId]);
});
Icon.propTypes = {
  /** Node for the individual icon import */
  content: PropTypes.node.isRequired,

  /** Optional class to be applied to the SVG element */
  className: PropTypes.string,

  /** Value for the <title> element describing the icon */
  title: PropTypes.string,
  role: PropTypes.string,

  /** By default points to the <title> element, if provided. */
  'aria-labelledby': PropTypes.string,

  /** By default is set to 'true' if no title or label is provided. */
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
Icon.defaultProps = {
  className: null,
  title: '',
  role: 'img',
  'aria-labelledby': undefined,
  'aria-hidden': undefined
};
export default Icon;